import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconCodeAlt = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M13.6571 4.26662C14.0622 4.35341 14.3201 4.7521 14.2334 5.15712L11.2334 19.1571C11.1466 19.5621 10.7479 19.8201 10.3429 19.7333C9.93784 19.6465 9.67986 19.2478 9.76665 18.8428L12.7667 4.84283C12.8534 4.43781 13.2521 4.17983 13.6571 4.26662Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.53033 7.46967C7.82322 7.76256 7.82322 8.23744 7.53033 8.53033L4.06066 12L7.53033 15.4697C7.82322 15.7626 7.82322 16.2374 7.53033 16.5303C7.23744 16.8232 6.76256 16.8232 6.46967 16.5303L2.46967 12.5303C2.17678 12.2374 2.17678 11.7626 2.46967 11.4697L6.46967 7.46967C6.76256 7.17678 7.23744 7.17678 7.53033 7.46967Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.4697 8.53033C16.1768 8.23744 16.1768 7.76256 16.4697 7.46967C16.7626 7.17678 17.2374 7.17678 17.5303 7.46967L21.5303 11.4697C21.8232 11.7626 21.8232 12.2374 21.5303 12.5303L17.5303 16.5303C17.2374 16.8232 16.7626 16.8232 16.4697 16.5303C16.1768 16.2374 16.1768 15.7626 16.4697 15.4697L19.9393 12L16.4697 8.53033Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconCodeAlt as ReactComponent };
